import { useTranslation } from "react-i18next";
import React from 'react';
import { Jumbotron } from 'reactstrap';
import { contactMetadata } from 'Modules/ContactModule';
import PropertyValue from 'Components/Personal/Property/PropertyValue';
import VerifyPersonalPhone from 'Components/Personal/Property/VerifyPersonalPhone';
import SendAgain from 'Components/SignUp/SendAgain';

function VerifyProperty({
  property
}) {
  const {
    t
  } = useTranslation();

  // t was removed because it was unused
  if (property.verified) {
    return null;
  }

  switch (property.name) {
    case 'emailAddresses':
      return <div className='pt-3'>
          <p>{t("Please click the link in the")}<strong>{t("verification email.")}</strong></p>{t("Haven't received the email?")}<SendAgain email={property.parameters[1].value} />
        </div>;

    case 'phoneNumbers':
      return <div className='pt-3'><VerifyPersonalPhone phoneObject={property} /></div>;

    default:
      return null;
  }
}

export default function Verification({
  property
}) {
  const {
    t
  } = useTranslation();
  const meta = { ...contactMetadata[property.name],
    name: property.name
  };
  return <Jumbotron>
      <h3>{meta.showName}{t("is")}{' '}
        {meta.verifiable && !property.verified ? <span className='text-danger'>{t("not verified")}</span> : <span className='text-primary'>{t("verified")}</span>}
      </h3>
      <div>{t("Details:")}<PropertyValue propertyMeta={meta} value={property} />
      </div>
      <VerifyProperty property={property} />
    </Jumbotron>;
}